import React, { useState, useCallback, useEffect } from 'react';
import cls from 'classnames';
import Image from 'next/image';
import { OFFICIAL_WEBSITE_URL, OFFICIAL_WEBSITE_EN_URL } from '../../../utils/constants';
import styles from './style.module.scss';
import { getUserDefaultLanguage, setLanguageCookie } from '../../../utils/cookie';
import logo from '/public/images/icon/logo.svg';

interface NavProps {
  className?: string;
  theme: 'MATH' | 'CHINESE' | 'ENGLISH';
  handleSelectLanguage?: (lang: string) => void;
  navHeaderClick?: () => void;
}

const Nav = ({ className, theme, handleSelectLanguage, navHeaderClick }: NavProps) => {
  const [showLanguage, setShowLanguage] = useState(false);
  const [language, setLanguage] = useState('en');

  const handleClick = () => {
    if (navHeaderClick) {
      navHeaderClick();
    }
  };

  const handleLanguageClick = useCallback(() => {
    setShowLanguage(!showLanguage);
    handleClick();
  }, [showLanguage]);

  const handleSelect = (lang: string) => {
    setLanguageCookie(lang as 'zh' | 'en');
    if (handleSelectLanguage) {
      handleSelectLanguage(lang);
    }
    setShowLanguage(false);
    setLanguage(lang);
  };

  useEffect(() => {
    setLanguage(getUserDefaultLanguage());
  }, []);

  return (
    <div>
      <div className={cls(className, styles.wrapper, styles[`theme-${theme}`])}>
        <div className={styles.logoBox}>
          <a target="_blank" href={language === 'zh' ? OFFICIAL_WEBSITE_URL : OFFICIAL_WEBSITE_EN_URL} rel="noreferrer">
            <Image className={styles.logoBoxImg} src={logo} alt="logo" width={101} height={34} />
          </a>
        </div>
        <div
          className={cls(styles.languageBox, {
            [styles.languageBoxActive]: showLanguage,
          })}
        >
          <div className={cls(styles.languageTextBox)} onClick={handleLanguageClick}>
            <span className={cls(styles.languageText)}>{language === 'zh' ? '中文' : 'ENGLISH'}</span>
          </div>
          <div className={cls(styles.languageSelectBox)}>
            <div
              className={cls(styles.languageSelectItem, {
                [styles.languageItemActive]: language === 'zh',
              })}
            >
              <a
                className={cls(styles.languageItemText)}
                onClick={() => {
                  handleSelect('zh');
                }}
              >
                中文
              </a>
            </div>
            <div
              className={cls(styles.languageSelectItem, {
                [styles.languageItemActive]: language === 'en',
              })}
            >
              <a
                className={cls(styles.languageItemText)}
                onClick={() => {
                  handleSelect('en');
                }}
              >
                ENGLISH
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.occupancy} />
    </div>
  );
};

export default Nav;
